import React, { useEffect, useState } from 'react';
import { FormMailingList } from '@luigiclaudio/ga-baseline-ui/auth';
import { ContentRenderer } from '@luigiclaudio/ga-baseline-ui/helpers';
import { buttonBtnTypeData, buttonSkinData } from '@luigiclaudio/ga-baseline-ui/button';
import useMailchimpFeedback from '../utils/useMailchimpFeedback';

var MailchimpForm = function MailchimpForm(_ref) {
  var status = _ref.status,
      message = _ref.message,
      onSubmit = _ref.onSubmit,
      buttonBtnType = _ref.buttonBtnType,
      buttonSkin = _ref.buttonSkin;
  var statusType;

  switch (status) {
    case 'error':
      statusType = 'info';
      break;

    case 'success':
      statusType = 'success';
      break;

    default:
      statusType = 'info';
  }

  var _useMailchimpFeedback = useMailchimpFeedback(),
      hasForm = _useMailchimpFeedback.hasForm,
      handleFeedbackMessage = _useMailchimpFeedback.handleFeedbackMessage,
      feedbackMessage = _useMailchimpFeedback.feedbackMessage,
      hasFeedback = _useMailchimpFeedback.hasFeedback,
      defaultTimeout = _useMailchimpFeedback.defaultTimeout;

  var _useState = useState(false),
      isSending = _useState[0],
      setIsSending = _useState[1];

  useEffect(function () {
    setIsSending(status === 'sending');
  }, [status]);
  useEffect(function () {
    if (isSending && message) {
      handleFeedbackMessage({
        type: statusType,
        message: /*#__PURE__*/React.createElement(ContentRenderer, {
          source: message
        })
      });
    }
  }, [isSending, statusType, message]);

  var handleMailingListSignUp = function handleMailingListSignUp(values) {
    var emailAddressMailingList = values.emailAddressMailingList;
    onSubmit({
      EMAIL: emailAddressMailingList
    });
  };

  return /*#__PURE__*/React.createElement(FormMailingList, {
    inProp: hasForm,
    inPropFeedback: hasFeedback,
    message: message,
    onSubmit: function onSubmit(values) {
      handleMailingListSignUp(values);
    },
    feedbackType: feedbackMessage.type,
    feedbackMessage: feedbackMessage.message,
    isLoading: isSending,
    buttonBtnType: buttonBtnType,
    buttonSkin: buttonSkin,
    resetFormTimeout: defaultTimeout
  });
};

MailchimpForm.defaultProps = {
  status: undefined,
  message: undefined,
  buttonSkin: undefined,
  buttonBtnType: undefined
};
export default MailchimpForm;